import client from '../client';
import type { NewsletterSubscriber } from '../../types/newsletter';
import type { ApiResponse, PaginationParams } from '../../types/api';

export const newsletterApi = {
  list: async (storeId: string, params?: PaginationParams) => {
    const res = await client.get<ApiResponse<{ subscribers: NewsletterSubscriber[]; pagination: { page: number; limit: number; total: number; pages: number } }>>(
      `/dashboard/${storeId}/newsletter`,
      { params },
    );
    return res.data.data!;
  },

  delete: async (storeId: string, subscriberId: string): Promise<void> => {
    await client.delete(`/dashboard/${storeId}/newsletter/${subscriberId}`);
  },

  exportCsv: async (storeId: string) => {
    const res = await client.post<ApiResponse<{ data: string }>>(
      `/dashboard/${storeId}/newsletter/export`,
    );
    return res.data.data!;
  },
};
